import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function PContactInfoComponent() {
    return (
        <address>
            <Row className="justify-content-center">
                <Col xs={12} sm={11} md={10} lg={9} xl={8}>
                    <address>
                        <h3 className='text-start'>Email</h3>
                        <a href="mailto:coinomania@gmail.com">coinomania@gmail.com</a>
                        <hr />
                        <h3 className='text-start'>Phone</h3>
                        <a href="tel:+17276562974">+1-727-656-2974</a>
                        <hr />
                        <h3 className='text-start' >Mailing Address</h3>
                        <p>To: FLGCE</p>
                        <p>P.O. Box:38</p>
                        <p>Lutz, Fl 33548</p>
                    </address>
                    {/*<a title="Customer reviews of flgoldcoinexchange.com"
                        target='_blank'
                        rel='noopener noreferrer nofollow'
                        href="https://www.webwiki.com/flgoldcoinexchange.com">
                        <img src="https://www.webwiki.com/etc/rating/widget/1380893098/flgoldcoinexchange-com-rating-full-180.png"
                            alt="Reviews of flgoldcoinexchange.com" />
                    </a>*/}
                </Col>
            </Row>
        </address>
    )
}